module.exports = __webpack_public_path__ + "c8b2ff4a30a2d657ea127f0f4c253019.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/logo.svg
// module id = 130
// module chunks = 1